import { Injectable } from '@angular/core';
import { firebaseApp } from '../../app.module';
import { getAnalytics, logEvent, setUserProperties } from 'firebase/analytics';

@Injectable({
    providedIn: 'root',
})
export class FirebaseAnalyticsService {
    userInfo: any;
    analytics: any;

    constructor() {
        this.getUserInfo();
        setUserProperties(this.analytics, this.userInfo);
    }

    getUserInfo() {
        this.analytics = getAnalytics(firebaseApp);
        this.userInfo = JSON.parse(localStorage.getItem('user'));

        setUserProperties(this.analytics, {
            exam: this.userInfo?.profileId?.exams,
            class: this.userInfo?.profileId?.class,
            board: this.userInfo?.profileId?.board,
            language: this.userInfo?.profileId?.language,
        });
    }

    logEvents(eventName: string, data?: any): void {
        data = data || {};
        if (data) {
            data['UserPhoneNumber'] = this.userInfo?.primaryNumber;
            data['UserId'] = this.userInfo?.id;
            data['userName'] = this.userInfo?.lastName
                ? this.userInfo?.firstName + ' ' + this.userInfo?.lastName
                : this.userInfo?.firstName;
        }
        try {
            logEvent(this.analytics, eventName, data);
        } catch (e) {
            console.log(e);
        }

        console.log(eventName, data);
    }
}
